import React from "react";
import { Button, Col, Modal, ListGroup, ProgressBar } from "react-bootstrap";
const ContactLens2 = ({ handleClose, Handleform1 }) => {
  return (
    <>
      <Col className='shadow' md={8}>
        <ProgressBar
          className=' Fpro shadow'
          variant='info'
          animated
          now={33}
        />
        <Modal.Header closeButton>
          <Button
            onClick={handleClose}
            size='sm'
            className='btn-light Psbutton shadow'
          >
            <i className='fa fa-arrow-left' aria-hidden='true'></i>
          </Button>
        </Modal.Header>

        <Modal.Title className='text-center'>
          Select Prescription Type
        </Modal.Title>
        <Modal.Body>
          <ListGroup variant='flush'>
            <ListGroup.Item>
              <Button
                size='sm'
                onClick={() => {
                  Handleform1("Spherical");
                }}
                className='Psbutton shadow btn-light'
              >
                Spherical Contact Lens
              </Button>
              <p className='my-2  FP'>
                Corrects for one field of vision (near, intermediate, or
                distance)
              </p>
            </ListGroup.Item>
            <ListGroup.Item>
              <Button
                size='sm'
                onClick={() => {
                  Handleform1("Toric");
                }}
                value='Toric'
                className='Psbutton shadow btn-light'
              >
                Toric Contact Lens
              </Button>
              <p className='my-2 FP'>
                A toric lens is shaped like a slice of the side of this donut.
              </p>
            </ListGroup.Item>
            <ListGroup.Item>
              <Button
                size='sm'
                onClick={() => {
                  Handleform1("Multi-focal");
                }}
                value='Multi-focal'
                className='Psbutton shadow btn-light'
              >
                Multi-Focal Contact Lens
              </Button>
              <p className='my-2 FP'>Distance & Near vision in same lenses.</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h6 className='my-2 FP'>
                Please choose the lens/Prescription depending upon need and your
                eye
              </h6>
            </ListGroup.Item>
          </ListGroup>
        </Modal.Body>
      </Col>
    </>
  );
};

export default ContactLens2;
